const IconArrowLeft = ({
  className = '',
  color = 'var(--neutral_7)',
  size = 20,
}: {
  className?: string;
  color?: string;
  size?: number;
}) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="12 6 20 20"
    fill="none"
  >
    <path
      d="M29.5005 16.0001C29.5005 16.1659 29.4346 16.3248 29.3174 16.442C29.2002 16.5593 29.0413 16.6251 28.8755 16.6251H16.6341L21.1927 21.1829C21.2507 21.241 21.2968 21.3099 21.3282 21.3858C21.3597 21.4617 21.3758 21.543 21.3758 21.6251C21.3758 21.7072 21.3597 21.7885 21.3282 21.8644C21.2968 21.9403 21.2507 22.0092 21.1927 22.0673C21.1346 22.1254 21.0657 22.1714 20.9898 22.2028C20.9139 22.2343 20.8326 22.2505 20.7505 22.2505C20.6684 22.2505 20.5871 22.2343 20.5112 22.2028C20.4353 22.1714 20.3664 22.1254 20.3083 22.0673L14.6833 16.4423C14.6252 16.3842 14.5791 16.3153 14.5476 16.2394C14.5162 16.1636 14.5 16.0822 14.5 16.0001C14.5 15.918 14.5162 15.8366 14.5476 15.7608C14.5791 15.6849 14.6252 15.616 14.6833 15.5579L20.3083 9.93292C20.4256 9.81564 20.5846 9.74976 20.7505 9.74976C20.9163 9.74976 21.0754 9.81564 21.1927 9.93292C21.31 10.0502 21.3758 10.2093 21.3758 10.3751C21.3758 10.541 21.31 10.7 21.1927 10.8173L16.6341 15.3751H28.8755C29.0413 15.3751 29.2002 15.441 29.3174 15.5582C29.4346 15.6754 29.5005 15.8343 29.5005 16.0001Z"
      fill={color}
    />
  </svg>
);

export default IconArrowLeft;
